<template>
  <div class="live-exchange">
    <div class="title">品牌展览交流</div>
    <div class="content">
      <div class="item">
        <div class="date"><i class="iconfont icon-shijian1"></i>直播时间</div>
        <div class="info">04/25 15:00</div>
      </div>
      <div class="item">
        <div class="date"><i class="iconfont icon-youxiaotonghuashichang"></i>距离开播时间还剩</div>
        <div class="info">26:15:20</div>
      </div>
      <div class="item">
        <div class="date"><i class="iconfont icon-shijian1"></i>直播时间</div>
        <div class="info">04/25 15:00</div>
      </div>
      <div class="item">
        <div class="date"><i class="iconfont icon-youxiaotonghuashichang"></i>距离开播时间还剩</div>
        <div class="info">26:15:20</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "live-exchange",
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.live-exchange {
  position: absolute;
  z-index: 102;
  top: 1.94rem;
  left: 0.2rem;
  width: calc(100% - 0.4rem);
  height: 4rem;
  border-radius: 0.1rem;
  color: #fff;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.8);
    filter: blur(3px);
    z-index: -1;
  }
  .title {
    font-size: 0.36rem;
    padding: 0.4rem 0 .35rem;
    text-align: center; 
  }
  .content {
    padding: 0 0.58rem 0 0.76rem;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%;
      margin-bottom: .4rem;
      .date {
        display: flex;
        align-items: center;
        font-size: 0.36rem;
        margin-bottom: 0.12rem;
        .iconfont {
            margin-right: .13rem;
        }
      }
      .info {
        display: flex;
        align-items: center;
        font-size: 0.24rem;
      }
    }
  }
}
</style>
